import { SuccessResponse } from 'shared/api/auth/auth.types'

export interface PasswordRecoveryRequest {
  email: string
  application: 'innos' | string
}

export type PasswordRecoveryResponse = SuccessResponse<{
  message: string
}>
